/* global Alpine */

/**
 * Cancellazione prenotazione (totale o singolo item via booite_id).
 */
export default function bookingCancel() {
  document.addEventListener('alpine:init', () => {
    Alpine.data('bookingCancel', () => ({
      config: {},
      modalOpen: false,
      targetBooiteId: null,

      policyStatus: 'loading',
      step: 'loading',
      error: null,
      preview: {},
      result: {},

      init() {
        const raw = this.$el.getAttribute('data-cancel-config')
        if (raw) {
          try {
            this.config = JSON.parse(raw)
          } catch {
            this.config = {}
          }
        }
        this.loadPolicy()
      },

      previewUrl() {
        const base =
          this.config.previewEndpoint || '/api?endpoint=cancel-booking-preview'
        if (!this.targetBooiteId) {
          return base
        }
        const sep = base.includes('?') ? '&' : '?'
        return `${base}${sep}booite_id=${encodeURIComponent(this.targetBooiteId)}`
      },

      async loadPolicy() {
        try {
          const res = await fetch(this.previewUrl(), {
            headers: { Accept: 'application/json' },
          })
          const data = await res.json()

          if (!res.ok || data.error) {
            this.policyStatus = 'error'
            return
          }

          this.preview = data.result || {}
          this.policyStatus = 'loaded'
        } catch {
          this.policyStatus = 'error'
        }
      },

      formatPrice(amount) {
        if (amount === undefined || amount === null) return ''
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: this.preview.currency || this.result.currency || 'EUR',
        }).format(amount)
      },

      hasExistingCredit() {
        return (this.preview.credit_current_gross || 0) > 0.005
      },

      previewCreditIncrement() {
        return this.preview.credit_increment_gross ?? 0
      },

      previewCreditTotal() {
        return (
          this.preview.credit_total_gross ??
          this.preview.refund_amount_gross ??
          0
        )
      },

      /** Importo transfer (scope) o totale pagato prenotazione. */
      previewBaseAmount() {
        const p = this.preview || {}
        if (
          p.display_base_amount !== undefined &&
          p.display_base_amount !== null
        ) {
          return p.display_base_amount
        }
        if (this.targetBooiteId) {
          return p.scope_line_gross ?? 0
        }
        return p.total_paid ?? p.scope_line_gross ?? 0
      },

      async openModal(booiteId = null) {
        this.targetBooiteId = booiteId || null
        this.modalOpen = true
        this.error = null
        this.step = 'loading'

        const strings = this.config.strings || {}

        try {
          const res = await fetch(this.previewUrl(), {
            headers: { Accept: 'application/json' },
          })
          const data = await res.json()

          if (!res.ok || data.error) {
            this.error = data.error || strings.loadingError || 'Errore.'
            this.step = 'error'
            return
          }

          this.preview = data.result || {}
          this.policyStatus = 'loaded'
          this.step = 'preview'
        } catch {
          this.error = strings.loadingError || 'Errore di caricamento.'
          this.step = 'error'
        }
      },

      async confirmCancel() {
        this.step = 'processing'
        this.error = null

        const strings = this.config.strings || {}

        try {
          const url =
            this.config.cancelEndpoint || '/api?endpoint=cancel-booking'
          const body = {
            booking_sid: this.config.bookingSid || '',
          }
          if (this.targetBooiteId) {
            body.booite_id = this.targetBooiteId
          }

          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(body),
          })

          const data = await res.json()

          if (!res.ok || data.error) {
            this.error = data.error || strings.cancelError || 'Errore.'
            this.step = 'error'
            return
          }

          this.result = data.result || {}
          this.step = 'done'
        } catch {
          this.error = strings.cancelError || 'Errore durante la cancellazione.'
          this.step = 'error'
        }
      },
    }))
  })
}
